var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"data-gtm":"header_logo_link","to":_vm.link}},[_c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":"/img/common/logo_sm.svg","alt":"We Meet Logo"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }